import React from 'react';

const icons = {
  youtube: (
    <svg viewBox="0 0 24 24" width="100%" height="100%" fill="#FF0000" aria-hidden="true">
      <path d="M23.498 6.186a2.994 2.994 0 0 0-2.108-2.116C19.228 3.5 12 3.5 12 3.5s-7.228 0-9.39.57A2.994 2.994 0 0 0 .502 6.186C0 8.36 0 12 0 12s0 3.64.502 5.814a2.994 2.994 0 0 0 2.108 2.116C4.772 20.5 12 20.5 12 20.5s7.228 0 9.39-.57a2.994 2.994 0 0 0 2.108-2.116C24 15.64 24 12 24 12s0-3.64-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  ),
  twitch: (
    <svg viewBox="0 0 24 24" width="100%" height="100%" fill="#9146FF" aria-hidden="true">
      <path d="M2.857 0L.286 4.286V21.43h5.143V24h3.429l3.429-2.571h4.286L23.714 16V0H2.857zm17.143 15.429l-2.571 2.571h-4.286l-3.429 2.571v-2.571H3.429V1.714h16.571v13.715z" />
    </svg>
  ),
  kick: (
    <svg viewBox="0 0 24 24" width="100%" height="100%" fill="#53FC18" aria-hidden="true">
      <path d="M3 3h5.2v6.2L14.5 3H21l-7.1 7.4L21 21h-6.6l-6.2-7.8V21H3V3z" />
    </svg>
  ),
  epg: (
    <svg viewBox="0 0 24 24" width="100%" height="100%" fill="none" stroke="#4ade80" strokeWidth="2" aria-hidden="true">
      <rect x="2" y="6" width="20" height="14" rx="2" />
      <path d="m8 2 4 4 4-4" />
    </svg>
  ),
};

const PlatformIcon = ({ platform, className = '' }) => {
  const key = String(platform || '').toLowerCase();
  const icon = icons[key];

  if (!icon) {
    return (
      <span className={`platform-icon platform-icon-fallback ${className}`} aria-hidden="true">
        ?
      </span>
    );
  }

  return (
    <span className={`platform-icon ${className}`} aria-hidden="true">
      {icon}
    </span>
  );
};

export default PlatformIcon;
